module.exports = __webpack_public_path__ + "cd6887244febaaaa6e36036765cc3d5a.png";